// remember to update confluence page after modifying this file
// https://dop-orange.atlassian.net/wiki/spaces/WUWA/pages/1827602540/Nju+Tagging+DataLayer

import { IProduct } from "./types";

type ICheckoutAdditionalPackageProps = {
  products: IProduct[];
};

export function pushCheckoutAdditionalPackageEvent({
  products,
}: ICheckoutAdditionalPackageProps) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "checkout",
      ecommerce: {
        checkout: {
          actionField: {
            step: 1,
            action: "checkout",
          },
          products,
        },
      },
      pageType: "eshop",
    });
  }
}
